<template>
    <b-card class="mt-5 appartment">
        <b-carousel
                id="carousel-1"
                controls
                indicators

        >
            <b-carousel-slide v-for="file in files" :key="file" :img-src="file">
            </b-carousel-slide>
        </b-carousel>
        <b-card-text>
            <h2>{{title}}</h2>
            <p>{{description}}</p>
        </b-card-text>
      <div class="d-flex justify-content-center">
        <b-button :href="link" style="color: #FF5A5F; background-color: white; border-color: #FF5A5F;" class="ml-auto mr-auto">
          <img src="/static/clipart1149625.png" width="18">
          Airbnb</b-button>
      </div>
    </b-card>
</template>

<script>

export default {
  name: 'Apartment',
  props: {
    title: null,
    files: null,
    link: null,
    description: null
  }
}
</script>

<style scoped>
  h2{
    text-align: left;
  }
p{
  text-align:  justify;
}
  .appartment{
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.20);
    -moz-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.20);
    box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.20);
  }

    p {
      font-size: 20px
    }
  @media (min-width: 992px) {
    .appartment{
      width: 70%;
      margin-left: 15%;
      margin-right: 15%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Appartment.vue